export default ({ t }) => (
  <div className="content">
    <h4 className="is-size-4 m-b-md">{t('common:contact-form_user-support')}</h4>
    <div className="m-b-md">{t('common:mazda-contact-support_line-1')} <a href="https://www.mazdausa.com/" target="_blank">www.mazdausa.com</a></div>    
    <div className="m-b-md">{t('common:mazda-contact-support_line-4')} <a href="/login">{t('common:mazda-contact-support_line-5')}</a> {t('common:mazda-contact-support_line-6')}</div>
    <div className="m-b-md">{t('common:mazda-contact-support_line-2')}</div>
  </div>
)



// WEBPACK FOOTER //
// ./components/Contact/NotAuthenticatedContactPage.js